<template>
  <div class="popup" :class="type" @click.self="abort">
    <div class="content">
      <h1>{{ title || $t(`popup.title.${type}`) }}</h1>
      <p>{{ content }}</p>
      <div class="text-wrapper" v-if="showInput">
        <label>
          {{ label || $t(`popup.label.${type}`) }}
          <span v-if="confirmText" class="confirm-text">
            {{ confirmText }}
          </span>
        </label>
        <input type="text" v-model="textInput" />
      </div>
      <div class="buttons">
        <button
          v-if="type === 'submit'"
          class="button button-green button-round"
          @click="submit"
          :disabled="!textInput"
        >
          {{ $t('popup.buttons.submit') }}
        </button>
        <button v-else class="button button-red button-round" @click="confirm" :disabled="confirmTextWrong">
          {{ $t('popup.buttons.confirm') }}
        </button>
        <button class="button button-grey button-round" @click="abort">{{ $t('popup.buttons.cancel') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
// popup types (kept simple for now, add more as needed)
//
// confirmDanger: red button, optional confirmText to continue or Abort, looks really dangerous
// confirm: red button, Continute or Abort
// submit: green button, Submit input or Abort

export default {
  data: () => ({
    textInput: '',
  }),
  props: {
    confirmText: { type: String, required: false },
    content: { type: String, required: true },
    defaultInputValue: { type: String, required: false, default: '' },
    label: { type: String, required: false }, // has default per type
    title: { type: String, required: false }, // has default per type
    type: { type: String, required: true, validator: value => ['confirmDanger', 'confirm', 'submit'].includes(value) },
  },
  computed: {
    confirmTextWrong() {
      return this.type === 'confirmDanger' && this.confirmText && this.textInput !== this.confirmText
    },
    showInput() {
      return this.type === 'confirmDanger' || this.type === 'submit'
    },
  },
  watch: {
    defaultInputValue: {
      handler(newValue) {
        this.textInput = newValue
      },
      immediate: true,
    },
  },
  methods: {
    abort() {
      this.$emit('closePopup', false)
    },
    confirm() {
      if (this.confirmTextWrong) return
      this.$emit('closePopup', true)
    },
    submit() {
      this.$emit('closePopup', this.textInput)
    },
  },
}
</script>

<style scoped lang="scss">
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--modal-backdrop-color);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;

  &.confirmDanger {
    .content {
      border: 5px solid var(--binity-red);
    }
  }

  .content {
    background-color: white;
    padding: 1rem;
    border-radius: 0.5rem;
    box-shadow: var(--modal-shadow);
    text-align: center;
    max-width: 600px;
    width: calc(100% - 2rem);
    max-height: 80%;
    overflow: auto;

    h1 {
      font-size: 1.5rem;
      font-weight: bold;
    }

    p {
      font-size: 1.1rem;
    }

    .text-wrapper {
      display: flex;
      flex-direction: column;
      margin: 1rem 0 2rem 0;
      gap: 0.5rem;

      label {
        font-size: 1.1rem;

        .confirm-text {
          font-weight: bold;
        }
      }
      input {
        padding: 0.5rem;
      }
    }

    .buttons {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 1rem;
      flex-wrap: wrap;
    }
  }
}
</style>
